import { render, staticRenderFns } from "./CustomDetailsDatepicker.vue?vue&type=template&id=3cfa9bfa&scoped=true"
import script from "./CustomDetailsDatepicker.vue?vue&type=script&lang=js"
export * from "./CustomDetailsDatepicker.vue?vue&type=script&lang=js"
import style0 from "./CustomDetailsDatepicker.vue?vue&type=style&index=0&id=3cfa9bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfa9bfa",
  null
  
)

export default component.exports